import { render, staticRenderFns } from "./AI-gold-start.vue?vue&type=template&id=275b0cfc&scoped=true&"
import script from "./AI-gold-start.ts?vue&type=script&lang=js&"
export * from "./AI-gold-start.ts?vue&type=script&lang=js&"
import style0 from "./AI-gold-start.less?vue&type=style&index=0&id=275b0cfc&lang=less&scoped=true&"
import style1 from "./AI-gold-start.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275b0cfc",
  null
  
)

export default component.exports